import { ButtonFloatingAddComponent } from './button-floating-add.component';

export const buttonFloatingAddModule = angular
  .module('sfMobile.components.button-floating-add', [
    'sfMobile.components.button-floating',
  ])
  .component('sfButtonFloatingAdd', ButtonFloatingAddComponent).name;
